function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.4989 24.7506C14.4989 24.4741 13.9303 23.921 14.2146 22.6766C14.4989 21.5704 17.1997 19.4963 20.3269 17.9753C24.3069 16.0395 23.0276 12.721 18.0525 7.46669C13.0775 2.21236 11.7982 -1.3827 5.8281 4.14817C-0.141973 9.67903 0.56875 14.1037 3.98022 23.5062C7.39169 32.9087 18.479 44.3852 28.0027 49.363C37.5264 54.3408 44.4914 54.8939 46.055 54.3408C47.6186 53.7877 51.4565 52.8198 54.868 46.8741C57.2845 42.5877 52.4515 40.3753 49.0401 37.7482C49.0401 37.7482 43.07 33.3235 40.9378 33.7383C38.8057 34.1531 36.9578 42.8642 33.1199 42.1729C29.282 41.4815 22.7433 35.6741 21.0376 33.4618C19.3318 31.2494 14.7832 25.8568 14.4989 24.7506Z",
  stroke: "white",
  strokeWidth: 4,
  strokeMiterlimit: 10
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 57,
  height: 56,
  fill: "white"
})));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.3329083d.svg";
export { ForwardRef as ReactComponent };